import { supabase } from './supabase'

const ADMIN_SESSION_KEY = 'wedding_admin_session'
const SESSION_TIMEOUT = 30 * 60 * 1000 // 30 minutes in milliseconds

/**
 * Verify admin password using database function with bcrypt
 */
export async function verifyAdminPassword(password: string): Promise<boolean> {
  try {
    // Call the database function to verify password with bcrypt
    const { data, error } = await supabase.rpc('verify_admin_password', {
      input_password: password
    })

    if (error) {
      console.error('Error verifying password:', error)
      return false
    }

    return data === true
  } catch (err) {
    console.error('Password verification error:', err)
    return false
  }
}

/**
 * Set admin session in localStorage with timestamp
 */
export function setAdminSession(): void {
  const session = {
    authenticated: true,
    timestamp: Date.now()
  }
  localStorage.setItem(ADMIN_SESSION_KEY, JSON.stringify(session))
}

/**
 * Check if admin session is valid (exists and not expired)
 */
export function isAdminAuthenticated(): boolean {
  try {
    const sessionData = localStorage.getItem(ADMIN_SESSION_KEY)
    
    if (!sessionData) {
      return false
    }

    const session = JSON.parse(sessionData)
    
    // Check if session is expired
    const isExpired = Date.now() - session.timestamp > SESSION_TIMEOUT
    
    if (isExpired) {
      clearAdminSession()
      return false
    }

    return session.authenticated === true
  } catch (err) {
    console.error('Session check error:', err)
    return false
  }
}

/**
 * Clear admin session (logout)
 */
export function clearAdminSession(): void {
  localStorage.removeItem(ADMIN_SESSION_KEY)
}

/**
 * Refresh admin session timestamp (extend session)
 */
export function refreshAdminSession(): void {
  if (isAdminAuthenticated()) {
    setAdminSession()
  }
}
